import { baseApi } from "api/BaseApi";

import type { LaiValidationDates, UpdateLaiDatesRequest } from "./lai.types";

export const laiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLaiValidationDates: builder.query<LaiValidationDates, number>({
      query: (vid) => ({
        url: `lai/lai/identify_validator_dates_by_vid/`,
        params: { vid },
      }),
      providesTags: ["LAI_VALIDATION_DATES"],
    }),

    updateLaiValidationDates: builder.mutation<void, UpdateLaiDatesRequest>({
      query: ({ vid, ...dates }) => ({
        url: `lai/lai/update_validator_dates_by_vid/`,
        method: "PUT",
        params: { vid },
        body: dates,
      }),
      invalidatesTags: ["LAI_VALIDATION_DATES"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetLaiValidationDatesQuery,
  useUpdateLaiValidationDatesMutation,
} = laiApi;
